import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import lang from '@/lang'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import LogoIcon from '@assets/images/logo/svg/logo-loader.svg'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    background: 'white',
    zIndex: 9,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  text: {
    display: 'inline-block',
    fontSsize: 12,
    marginTtop: 15,
  },
  pulse: {
    animation: 'pulse 2s ease infinite',
  },
  '@keyframes pulse': {
    '0%': { fill: '#135899' },
    '50%': { fill: '#EE751C' },
    '100%': { fill: '#135899' },
  },
}))

const Loader = (props) => {
  const { customClass, text, height, width, visible, className, iconHeight, onCancel } = props
  const classes = useStyles()

  if (!visible) return null

  const renderCancelLink = () => {
    if (!onCancel) {
      return
    }

    return (
      <div>
        <a onClick={onCancel}>{lang.cancelButtonLabel}</a>
      </div>
    )
  }

  return (
    <div className={clsx(classes.container, customClass, className)} style={{ height, width }}>
      <div className={classes.content}>
        <SVGIcon height={iconHeight} width="auto" svg={LogoIcon} className={classes.pulse} />
        <span className={classes.text}>{text}</span>
        {renderCancelLink()}
      </div>
    </div>
  )
}

Loader.defaultProps = {
  visible: true,
  width: '100%',
  iconHeight: '50px',
}

export default Loader
